import { AVAILABLE_AI_FEATURES } from "@foodlista/shared/ai/types"
import { LOCALE_KEYS } from "@foodlista/shared/i18n/constants"
import { z } from "zod"
import { defineOperationContext } from "../define"
import {
	type TextGenerateInput,
	internalOriginPathSchema,
} from "../schemas/text-generate"

export const textGenerateContextSchema = z.object({
	scopeKey: z.string().min(1).max(300),
	feature: z.enum(AVAILABLE_AI_FEATURES),
	locale: z.enum(LOCALE_KEYS).optional(),
	originPath: internalOriginPathSchema.optional(),
})

export type TextGenerateContext = z.infer<typeof textGenerateContextSchema>

export const textGenerateContextSpec = defineOperationContext<
	TextGenerateInput,
	TextGenerateContext
>({
	version: 1,
	schema: textGenerateContextSchema,
	fromInput: (input) => ({
		scopeKey: input.scopeKey,
		feature: input.feature,
		locale: input.locale,
		originPath: input.originPath,
	}),
})
